





import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class Label extends Vue {
  @Prop({default:''}) public text: string;
  @Prop({default:16}) public fontSize:number;  
  @Prop({default:600}) public fontWeight:number;      
  @Prop({default:null}) public tooltip: string;  
  public mounted() {
    if(this.tooltip) this.$nextTick(()=>this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip));
  }  
}

